"use strict";

require("core-js/modules/es.object.define-property.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function cov_al438pzix() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Geo.tsx";
  var hash = "7a34924099d7b536337a92379f605f2682fa8692";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Geo.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 43
        },
        end: {
          line: 4,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "7a34924099d7b536337a92379f605f2682fa8692"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_al438pzix = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_al438pzix();
var Icon = (cov_al438pzix().s[0]++, {
  name: 'geo',
  svg: "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M13.4251 9.94692L14.5996 15.1005L18.4318 5.46445L8.19075 7.7389L13.4251 9.94692ZM11.2724 11.7522L13.3493 20.8655C13.5324 21.6694 14.6435 21.7553 14.9481 20.9892L21.9138 3.47387C22.1629 2.84751 21.6096 2.19775 20.9516 2.3439L2.5689 6.42656C1.77042 6.60389 1.67097 7.70198 2.4246 8.01988L11.2724 11.7522Z\" fill=\"currentColor\"/>"
});
var _default = exports["default"] = Icon;